import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, Ghost, SearchX, Layers } from 'lucide-react';
import { Card } from './ui/Card';
export function ProblemsSection() {
  const problems = [{
    icon: ShieldAlert,
    title: 'Unsafe Content',
    desc: 'Too many games expose kids to inappropriate ads and chat rooms.',
    color: 'text-candy-pink',
    bg: 'bg-candy-pink/10'
  }, {
    icon: Ghost,
    title: 'Ad Overload',
    desc: 'Constant interruptions ruin the fun and accidentally click to sketchy sites.',
    color: 'text-candy-purple',
    bg: 'bg-candy-purple/10'
  }, {
    icon: SearchX,
    title: 'Hard to Find',
    desc: 'Good games are buried under thousands of low-quality clones.',
    color: 'text-candy-teal',
    bg: 'bg-candy-teal/10'
  }, {
    icon: Layers,
    title: 'Fragmented',
    desc: 'Jumping between different apps and stores is a hassle for parents.',
    color: 'text-candy-yellow',
    bg: 'bg-candy-yellow/10'
  }];
  return <section className="py-20 bg-white" data-id="element-161">
      <div className="container mx-auto px-4 md:px-6" data-id="element-162">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-163">
          <h2 className="text-4xl md:text-5xl font-bold text-candy-dark mb-4" data-id="element-164">
            Why Kids (and Parents) Need{' '}
            <span className="text-candy-pink" data-id="element-165">Prismgames</span>
          </h2>
          <p className="text-xl text-gray-500" data-id="element-166">
            The internet is a big place. We built a walled garden where fun
            meets safety.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-167">
          {problems.map((item, index) => <Card key={index} className="p-6 border-none shadow-lg hover:shadow-xl transition-shadow" hoverEffect={true} data-id="element-168">
              <div className={`w-16 h-16 rounded-2xl ${item.bg} flex items-center justify-center mb-6 mx-auto`} data-id="element-169">
                <item.icon className={`w-8 h-8 ${item.color}`} data-id="element-170" />
              </div>
              <h3 className="text-2xl font-bold text-center text-gray-800 mb-3" data-id="element-171">
                {item.title}
              </h3>
              <p className="text-center text-gray-500 leading-relaxed" data-id="element-172">
                {item.desc}
              </p>
            </Card>)}
        </div>

        <div className="mt-20 text-center" data-id="element-173">
          <div className="inline-block p-1 rounded-full bg-gradient-to-r from-candy-pink via-candy-purple to-candy-teal" data-id="element-174">
            <div className="bg-white rounded-full px-8 py-4" data-id="element-175">
              <p className="text-xl md:text-2xl font-bold text-candy-dark" data-id="element-176">
                🚀 We solved this. Welcome to the future of safe play.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}